module.exports = __webpack_public_path__ + "img/rutv.193130af.svg";